import { render, staticRenderFns } from "./StatsDetailsContainer.vue?vue&type=template&id=2e790262&"
import script from "./StatsDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./StatsDetailsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports